import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  LayoutDashboard, Clapperboard, Users, Eye, Heart, PartyPopper, CalendarCheck, Settings2,
  Inbox, Pencil, Star, BarChart3, UserCog, BookOpen, Wallet, Award, FileInput, Globe2, Mail,
} from "lucide-react";

const Item = ({ value, label, icon: Icon, badge, testId }) => (
  <TabsTrigger
    value={value}
    data-testid={testId || `tab-${value}`}
    className="justify-start gap-2.5 w-auto lg:w-full px-3 py-2 rounded-lg text-foreground/65 hover:text-foreground hover:bg-white/[0.04] transition-colors data-[state=active]:bg-terracotta/15 data-[state=active]:text-foreground data-[state=active]:shadow-none data-[state=active]:ring-1 data-[state=active]:ring-terracotta/40 shrink-0"
  >
    <Icon className="w-4 h-4 shrink-0" />
    <span className="truncate">{label}</span>
    {badge > 0 && <span className="ml-auto text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-gold/20 text-gold">{badge}</span>}
  </TabsTrigger>
);

const Group = ({ label }) => (
  <p className="hidden lg:block text-[10px] uppercase tracking-[0.25em] text-foreground/40 font-semibold px-3 pt-5 pb-2 first:pt-0">{label}</p>
);

export default function AdminSidebar({ counts = {} }) {
  return (
    <TabsList
      className="h-auto bg-surface/60 backdrop-blur border border-white/10 rounded-2xl p-2 flex lg:flex-col items-stretch justify-start gap-1 overflow-x-auto lg:overflow-visible lg:sticky lg:top-24 self-start w-full"
      data-testid="admin-sidebar"
    >
      <Group label="Overview" />
      <Item value="overview" label="Overview" icon={LayoutDashboard} />
      <Item value="films" label="Films" icon={Clapperboard} />
      <Item value="filmmaker-overview" label="Filmmakers" icon={Users} />
      <Item value="viewers" label="Viewers" icon={Eye} />
      <Item value="geo" label="Geo Insights" icon={Globe2} />
      <Item value="donations" label="Donations" icon={Heart} />
      <Item value="watch-parties" label="Watch Parties" icon={PartyPopper} />
      <Item value="event" label="Event" icon={CalendarCheck} testId="tab-event-registrations" />
      <Item value="site" label="Team & Site" icon={Settings2} />
      <Group label="Operations" />
      <Item value="pending" label="Pending review" icon={Inbox} badge={counts.pending} />
      <Item value="all" label="Film editing" icon={Pencil} testId="tab-all-films" />
      <Item value="spotlight" label="Spotlight" icon={Star} />
      <Item value="performance" label="Film performance" icon={BarChart3} testId="tab-film-performance" />
      <Item value="filmmakers" label="Filmmaker accounts" icon={UserCog} />
      <Item value="journal" label="Journal" icon={BookOpen} />
      <Item value="payouts" label="Payouts" icon={Wallet} badge={counts.payouts} />
      <Item value="festivals" label="Festival requests" icon={Award} testId="tab-festival-requests" badge={counts.festivals} />
      <Item value="submissions" label="Film submissions" icon={FileInput} />
      <Item value="broadcast" label="Broadcast email" icon={Mail} testId="tab-broadcast-email" />
    </TabsList>
  );
}
